/**
 * Gemeinsame Orientierungs-/Crop-Helfer. Vorher dreimal kopiert (cropPreset.ts,
 * persistedOrientation.ts, CanvasCropperLite.vue) mit leicht abweichenden Kanten.
 */
export function normRot(value: unknown): 0 | 90 | 180 | 270 {
  const raw = Math.round(Number(value) || 0)
  const normalized = ((raw % 360) + 360) % 360
  if (normalized === 90 || normalized === 180 || normalized === 270) return normalized
  return 0
}

/** Fläche des größten Rechtecks mit Seitenverhältnis `ar`, das in boxW×boxH passt. */
export function maxAreaForAspect(boxW: number, boxH: number, ar: number): number {
  if (!(boxW > 0) || !(boxH > 0) || !(ar > 0) || !Number.isFinite(ar)) return 0
  const boxAr = boxW / boxH
  let w = boxW
  let h = boxH
  if (boxAr >= ar) {
    h = boxH
    w = h * ar
  } else {
    w = boxW
    h = w / ar
  }
  return Math.max(0, w) * Math.max(0, h)
}

/** Größter zentrierter Ausschnitt mit Seitenverhältnis `ar` in width×height (ganzzahlig). */
export function maxCropForAspect(width: number, height: number, ar: number): { left: number; top: number; width: number; height: number } {
  const maxW = Math.max(2, Math.round(width))
  const maxH = Math.max(2, Math.round(height))
  if (!(ar > 0) || !Number.isFinite(ar)) {
    return { left: 0, top: 0, width: maxW, height: maxH }
  }
  const imageAr = maxW / Math.max(1, maxH)
  let cropW = maxW
  let cropH = maxH
  if (imageAr > ar) {
    cropH = maxH
    cropW = Math.max(2, Math.round(cropH * ar))
  } else {
    cropW = maxW
    cropH = Math.max(2, Math.round(cropW / ar))
  }
  return {
    left: Math.max(0, Math.round((maxW - cropW) / 2)),
    top: Math.max(0, Math.round((maxH - cropH) / 2)),
    width: cropW,
    height: cropH,
  }
}

/** Ob das gespiegelte Seitenverhältnis (1/ar) mehr Bildfläche nutzt als `ar`. */
export function shouldSwapAspect(boxW: number, boxH: number, ar: number): boolean {
  if (!(boxW > 0) || !(boxH > 0) || !(ar > 0) || !Number.isFinite(ar)) return false
  return maxAreaForAspect(boxW, boxH, 1 / ar) > maxAreaForAspect(boxW, boxH, ar)
}
